import React, { lazy } from 'react';
import { MapPinIcon, UsersIcon, CheckCircleIcon } from 'lucide-react';
export function CreatorSection() {
  return <section className="py-12 mb-12 bg-amber-50 rounded-lg" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-6" data-id="element-80">
          La Historia de Stella
        </h2>
        <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-81">
          30+ Años Perfeccionando el Arte de la Repostería Uruguaya
        </p>
        <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-82">
          <div className="w-full md:w-1/3" data-id="element-83">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jNnb1wb7nerKB9Uf6sYWGt/Generated_Image_September_02%2C_2025_-_11_04PM.jpg" alt="Stella Pereira decorando un pastel en su cocina profesional" className="w-48 h-48 mx-auto rounded-full object-cover border-4 border-amber-200" loading="lazy" width="192" height="192" decoding="async" data-id="element-84" />
          </div>
          <div className="w-full md:w-2/3" data-id="element-85">
            <div className="bg-white p-6 rounded-lg shadow-sm relative" data-id="element-86">
              <div className="text-amber-800 text-6xl font-serif absolute top-2 left-4 opacity-20" data-id="element-87">
                "
              </div>
              <p className="text-gray-700 relative z-10 mb-6" data-id="element-88">
                "Durante más de 30 años trabajé en las mejores reposterías de
                Uruguay y Punta del Este, perfeccionando cada técnica. Cuando
                intenté enseñar milhojas a mi familia, siempre pasaba lo mismo:
                las capas se inflaban, la torta quedaba chata o el merengue se
                bajaba antes de cantar el cumpleaños.
                <br data-id="element-89" />
                <br data-id="element-90" />
                Era frustrante… hasta que decidí sistematizar las técnicas
                exactas que usamos los pasteleros profesionales. Mi experiencia
                en las principales pastelerías de Punta del Este me enseñó los
                secretos que hacen la diferencia.
                <br data-id="element-91" />
                <br data-id="element-92" />
                Después de capacitar a más de 1,200 alumnos y ver sus resultados
                extraordinarios, puedo asegurarte que con este método vas a
                lograr una milhojas perfecta desde el primer intento."
              </p>
              <div className="text-center" data-id="element-93">
                <p className="font-bold text-amber-900" data-id="element-94">Stella Pereira</p>
                <p className="text-sm text-amber-700" data-id="element-95">
                  Maestra Pastelera Profesional
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center" data-id="element-96">
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center" data-id="element-97">
            <MapPinIcon size={24} className="text-amber-600 mb-2" data-id="element-98" />
            <p className="font-medium text-amber-900" data-id="element-99">Punta del Este</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center" data-id="element-100">
            <UsersIcon size={24} className="text-amber-600 mb-2" data-id="element-101" />
            <p className="font-medium text-amber-900" data-id="element-102">1,200+ Alumnos</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center" data-id="element-103">
            <CheckCircleIcon size={24} className="text-amber-600 mb-2" data-id="element-104" />
            <p className="font-medium text-amber-900" data-id="element-105">Método Comprobado</p>
          </div>
        </div>
      </div>
    </section>;
}